module.exports = __webpack_public_path__ + "static/img/img-021.c82cbbc.jpg";